/**
 * The voltage methodology write-up, read from `docs/voltage.md` at build time.
 *
 * A parallel task owns the prose. This module renders whatever is on disk and
 * nothing else - if the file has not landed yet the glob simply matches nothing
 * and the modal shows a placeholder naming the missing path, rather than this
 * branch inventing a methodology of its own.
 *
 * `import.meta.glob` is used instead of a direct `?raw` import precisely because
 * a direct import of a missing file is a build error.
 *
 * The pattern names the one file rather than `docs/*.md`, which is what it used
 * to be: a wildcard here inlines *every* markdown file in `docs/` into the
 * client bundle, so the deployment notes and the publishing runbook were being
 * downloaded by every visitor to be thrown away - 33 kB of internal prose, and
 * growing by the size of whatever anybody added to `docs/` next.
 */

const DOCS = import.meta.glob('../../../../../docs/voltage.md', {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>

const entry = Object.entries(DOCS).find(([path]) => path.endsWith('/voltage.md'))

/** `null` when `docs/voltage.md` is not in the repository yet. */
export const VOLTAGE_METHODOLOGY: string | null =
  entry === undefined || entry[1].trim() === '' ? null : entry[1]

/** Where the write-up is expected to live, quoted in the placeholder. */
export const VOLTAGE_METHODOLOGY_PATH = 'docs/voltage.md'
